module.exports = __webpack_public_path__ + "img/sub-branch.a86c5175.svg";